import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import PageContainer from '@/components/PageContainer';
import PageHeader from '@/components/PageHeader';

export default function Formations() {
  const { t } = useLang();
  const f = t.formations;

  return (
    <PageContainer>
      <PageHeader kicker={f.kicker} title={f.title} lead={f.intro} />

      {/* Actualités sociales */}
      <section className="mt-16 animate-fade-up" data-testid="section-actualites">
        <div className="flex items-baseline gap-4 mb-6">
          <span className="font-display text-4xl text-[var(--color-gold)]">01</span>
          <h2 className="font-display text-2xl md:text-3xl text-navy">{f.actuTitle}</h2>
        </div>
        <div className="space-y-5 text-[16px] leading-[1.85] text-navy/80 pl-2 md:pl-12 border-l border-[var(--color-taupe)]/30 text-justify">
          <p>{f.actuP1}</p>
          <p>{f.actuP2}</p>
          <p>{f.actuP3}</p>
          <ul className="space-y-2">
            {f.actuBullets.map((b, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="mt-2 h-1.5 w-1.5 rotate-45 bg-[var(--color-gold)] flex-shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
          <p className="italic text-navy/70">{f.actuOutro}</p>
        </div>
      </section>

      {/* Thématiques */}
      <section className="mt-16 animate-fade-up" data-testid="section-thematiques">
        <div className="flex items-baseline gap-4 mb-6">
          <span className="font-display text-4xl text-[var(--color-gold)]">02</span>
          <h2 className="font-display text-2xl md:text-3xl text-navy">{f.themTitle}</h2>
        </div>
        <div className="space-y-5 text-[16px] leading-[1.85] text-navy/80 pl-2 md:pl-12 border-l border-[var(--color-taupe)]/30 text-justify">
          <p>{f.themP1}</p>
          <p>{f.themP2}</p>
          <p>{f.themP3}</p>
        </div>
      </section>

      {/* Examples */}
      <section className="mt-16 animate-fade-up" data-testid="section-examples">
        <div className="flex items-baseline gap-4 mb-6">
          <span className="font-display text-4xl text-[var(--color-gold)]">03</span>
          <h2 className="font-display text-2xl md:text-3xl text-navy">{f.examplesTitle}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {f.examples.map((ex, i) => (
            <div
              key={i}
              className="flex items-start gap-3 bg-white p-4 hover:bg-[var(--color-cream-light)] border border-[var(--color-taupe)]/15 transition-colors"
            >
              <span className="text-[var(--color-gold)] font-display text-lg leading-none mt-0.5">—</span>
              <p className="text-[14.5px] leading-snug text-navy/85">{ex}</p>
            </div>
          ))}
        </div>
      </section>
    </PageContainer>
  );
}
